var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.zoneSlot.imageSlots.length > 0)?_c('ImageCollectionSlot',{attrs:{"zoneSlot":_vm.zoneSlot,"userZoneSlot":_vm.userZoneSlot,"imageSlot":_vm.getImageSlot()}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }